import React from 'react';

import { FastshiftRunbookProduct } from '@wac-web/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client.types';
import { FormattedMessage } from 'react-intl';

import Lozenge from '@atlaskit/lozenge';
import { Box, Inline, Text, xcss } from '@atlaskit/primitives';

import { messages } from '../messages';

const metadataLabelStyles = xcss({
	flexShrink: 0,
	width: '76px',
});

const runbookProductMessageMapping = {
	JIRA: messages.runbooksPanelJiraProductName,
	CONFLUENCE: messages.runbooksPanelConfluenceProductName,
};

type MetadataRowProps = {
	label: React.ReactNode;
	children: React.ReactNode;
};

const MetadataRow: React.FC<MetadataRowProps> = ({ label, children }) => (
	<Inline alignBlock="baseline" space="space.100">
		<Box xcss={metadataLabelStyles}>
			<Text size="small" color="color.text.subtle">
				{label}
			</Text>
		</Box>
		<Box>{children}</Box>
	</Inline>
);

export type RunbookProductMetadataProps = {
	product: FastshiftRunbookProduct;
};

export const RunbookProductMetadata: React.FC<RunbookProductMetadataProps> = ({ product }) => (
	<MetadataRow label={<FormattedMessage {...messages.runbooksPanelProductLabel} />}>
		<Lozenge appearance="inprogress">
			<FormattedMessage {...runbookProductMessageMapping[product]} />
		</Lozenge>
	</MetadataRow>
);

export type RunbookResponsibleMetadataProps = {
	value: string;
};

export const RunbookResponsibleMetadata: React.FC<RunbookResponsibleMetadataProps> = ({
	value,
}) => (
	<MetadataRow label={<FormattedMessage {...messages.runbooksPanelResponsibleLabel} />}>
		<Lozenge appearance="default">{value}</Lozenge>
	</MetadataRow>
);
